// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownSquareTwoToneSvg from "@fishx/icons-svg/es/asn/DownSquareTwoTone";
import FishxIcon from '../components/FishxIcon';

var DownSquareTwoTone = function DownSquareTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareTwoToneSvg
  }));
};

DownSquareTwoTone.displayName = 'DownSquareTwoTone';
export default React.forwardRef(DownSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DownSquareTwoTone.js
// module id = 2468
// module chunks = 0